module.exports = __webpack_public_path__ + "img/cyberpunk.0f74677e.png";